import { Controller } from "@hotwired/stimulus"

// A "Watch the video" button and the modal it opens. The player iframe gets
// its src only when opened, so the page never loads it for people who don't
// press play, and loses it again on close so the video stops.
export default class extends Controller {
  static targets = ["dialog", "frame"]
  static values = { src: String }

  connect() {
    this.handleEscape = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("keydown", this.handleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    if (event) event.preventDefault()
    this.frameTarget.src = this.srcValue
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.dialogTarget.classList.contains("hidden")) return
    this.dialogTarget.classList.add("hidden")
    this.frameTarget.removeAttribute("src")
    document.body.classList.remove("overflow-hidden")
  }

  stop(event) {
    event.stopPropagation()
  }
}
